import { render } from "./RestaurantHistory.vue?vue&type=template&id=f2a3c08c&scoped=true"
import script from "./RestaurantHistory.vue?vue&type=script&lang=js"
export * from "./RestaurantHistory.vue?vue&type=script&lang=js"

import "./RestaurantHistory.vue?vue&type=style&index=0&id=f2a3c08c&scoped=true&lang=css"

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a3c08c"]])

export default __exports__